module.exports = __webpack_public_path__ + "images/dockr_smallafba633d6766f930367f4de13a38bf2d.png";